// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TypeheadField_wrapper__BjcdC","bordered":"TypeheadField_bordered__1y8gn"};